<template>
  <div class="home">

    <!-- Navigation -->
    <nav id="main-nav">
      <div class="container d-flex justify-content-between align-items-center py-2 py-md-3">
        <MobiusLogo />
        <div class="d-flex align-items-center">
          <router-link to="/v2/auth/login" class="btn d-block color-ing">Ingresa</router-link>
          <router-link to="/v2/auth/register" class="btn btn-primary d-block ml-3 color-register">Regístrate</router-link>
        </div>
      </div>
    </nav>
    <!-- End Navigation -->

    <!-- Hero section -->
    <div class="hero">
      <div class="container">
        
        <div class="row">
          <div class="col-md">
            <h1 class="font-h1">Aprende más, estudia menos!</h1>
            <p>
              Mobius utiliza técnicas de Machine Learning e Inteligencia Artificial
              para optimizar tu aprendizaje, dentro y fuera del aula, haciendo
              que cada minuto de estudio cuente.
            </p>
          </div>  
          <div class="col-md">
            <div class="hero__video-container mt-5 mt-lg-0 olympics-container">
              <div class="btn-stack">
                <div class="col-md">
            <div class="hero__video-container mt-5 mt-lg-0 olympics-container">
              <h2 class="olympics-container">Nuevos Cursos</h2>
              </div>
            </div>  
                <router-link to="/olimpiadas" class="btn btn-olimpiadas">Olimpiadas 2026</router-link>
                <router-link to="login" class="btn btn-olimpiadas">Pre-ICFES 2026</router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    
    </div>
    <!-- End Hero section -->
   <!-- Aplicaciones Matemáticas -->
   <div id="aplicaciones" class="section container">
      <div class="row align-items-center">
        <div class="col-md-6">
          <h2 class="heading-2"><b>Aplicaciones Matemáticas</b></h2>
          <p>Descubre cómo las matemáticas se usan en tecnología, finanzas y negocios con expertos de la industria.</p>
          <router-link to="/infographic" class="btn btn-olimpiadas">Ver curso</router-link>
        </div>
        <div class="col-md-6 mt-4 mt-md-0">
          <div class="apps-logos">
            <infinite-slide-bar>
              <div class="items flex">
                <img src="/src/assets/logos/amazon.svg" alt="amazon" class="w-16 h-10 object-contain" />
                <img src="/src/assets/logos/apple.svg" alt="apple" class="w-16 h-10 object-contain" />
                <img src="/src/assets/logos/google.svg" alt="google" class="w-16 h-10 object-contain" />
                <img src="/src/assets/logos/meta.svg" alt="meta" class="w-16 h-10 object-contain" />
                <img src="/src/assets/logos/microsoft.svg" alt="microsoft" class="w-16 h-10 object-contain" />
                <img src="/src/assets/logos/tesla.svg" alt="tesla" class="w-16 h-10 object-contain" />
              </div>
            </infinite-slide-bar>
          </div>
        </div>
      </div>
    </div>
    <!-- Why Mobius Section -->
    <div id="why-mobius" class="section section-tight-top container mt-0 mb-5">
      <div class="col-md">
        <h1 class="font-h1 hero-title font-black">¿Por qué Mobius?</h1>
      </div>
      <div class="row">
        <div class="col-md-4 mb-4">
          <div class="card h-100 text-center p-4 shadow-sm border-0 why-card">
            <div class="card-body">
              <h5 class="font-weight-bold mb-3">Seguimiento en tiempo real</h5>
              <p class="mb-0">
                Mobius provee al estudiante un reporte de desesmpeño personalizado
                que identifica sus fortalezas y prioriza los temas que debe mejorar.
              </p>
            </div>
          </div>
        </div>
        <div class="col-md-4 mb-4">
          <div class="card h-100 text-center p-4 shadow-sm border-0 why-card">
            <div class="card-body">
              <h5 class="font-weight-bold mb-3">Inteligencia educativa</h5>
              <p class="mb-0">
                Profesores y directivos acceden a reportes de desempeño
                individuales y grupales que ayudan a optimizar el proceso de enseñanza–aprendizaje.
              </p>
            </div>
          </div>
        </div>
        <div class="col-md-4 mb-4">
          <div class="card h-100 text-center p-4 shadow-sm border-0 why-card">
            <div class="card-body">
              <h5 class="font-weight-bold mb-3">Microlecciones</h5>
              <p class="mb-0">
                Mobius usa microlecciones que permiten a los estudiantes aprender
                conceptos clave en minutos y reforzarlos con práctica inmediata
                para consolidar su aprendizaje.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Premium Benefits -->
    <div id="estudiantes-profesores" class="section  container mt-0 mb-5 premium-benefits">
      <div class="col-md">
        <h1 class="font-h1 hero-title font-black">Mobius Premium</h1>
      </div>
      <div class="premium-table-wrap">
        <table class="premium-table">
          <thead>
            <tr>
              <th>Funcionalidad</th>
              <th class="text-center">Plan Grátis</th>
              <th class="text-center premium-col">Plan Premium</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Acceso a la plataforma</td>
              <td class="text-center">Acceso básico</td>
              <td class="text-center premium-col">Acceso completo</td>
            </tr>
            <tr>
              <td>Cursos disponibles</td>
              <td class="text-center">5 cursos</td>
              <td class="text-center premium-col">10+ cursos</td>
            </tr>
            <tr>
              <td>Lecciones disponibles</td>
              <td class="text-center">40 lecciones</td>
              <td class="text-center premium-col">200+ lecciones</td>
            </tr>
            <tr>
              <td>Lecciones premium</td>
              <td class="text-center">No incluidas</td>
              <td class="text-center premium-col">Incluidas</td>
            </tr>
            <tr>
              <td>Preguntas disponibles</td>
              <td class="text-center">150 preguntas</td>
              <td class="text-center premium-col">1.500+ preguntas</td>
            </tr>
            <tr>
              <td>Simulacros disponibles</td>
              <td class="text-center">5 simulacros</td>
              <td class="text-center premium-col">20+ simulacros</td>
            </tr>
            <tr>
              <td>Presentar simulacros</td>
              <td class="text-center">Sí</td>
              <td class="text-center premium-col">Sí</td>
            </tr>
            <tr>
              <td>Revisión de simulacros</td>
              <td class="text-center">No disponible</td>
              <td class="text-center premium-col">Revisión completa al finalizar</td>
            </tr>
            <tr>
              <td>Reportes generales de desempeño</td>
              <td class="text-center">No disponible</td>
              <td class="text-center premium-col">Incluidos</td>
            </tr>
            <tr>
              <td>Reportes por curso</td>
              <td class="text-center">No disponibles</td>
              <td class="text-center premium-col">Incluidos</td>
            </tr>
            <tr>
              <td>Seguimiento del progreso</td>
              <td class="text-center">Básico</td>
              <td class="text-center premium-col">Avanzado</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <!-- End Premium Benefits -->

    <!-- Footer -->
    <footer id="contacto" class="section contact-footer">
      <div class="container text-center">
        <p class="font-3 mb-5">Contáctanos administrador@mobiusml.com</p>
      </div>
      <footer-copy />
    </footer>
    <!-- End Footer -->

  </div>
</template>

<script>
import FooterCopy from "@/components/FooterCopy.vue";
import MobiusLogo from "@/components/MobiusLogo.vue";
import InfiniteSlideBar from "vue-infinite-slide-bar";

export default {
  name: "Home",
  components: {
    FooterCopy,
    MobiusLogo,
    InfiniteSlideBar,
  },
  data() {
    return {
      slide: 0,
      sliding: null,
    };
  },
  methods: {
    getGraphUrl(graphName) {
      return new URL(`../../assets/images/banners/${graphName}`, import.meta.url).href;
    },
    goToOlimpiadas() {
      this.$router.push(`/olimpiadas`);
    },
  },
  mounted() {
    // Navigation scroll effect
    window.addEventListener("scroll", function () {
      const nav = document.getElementById("main-nav");
      if (document.documentElement.scrollTop > window.innerHeight || document.body.scrollTop > window.innerHeight) {
        nav.classList.add("bg-white", "border-bottom");
      } else {
        nav.classList.remove("bg-white", "border-bottom");
      }
    });
  },
};
</script>

<style scoped>
:root {
  --font-body: "Public Sans", arial, sans-serif;
  --heading-1: normal 700 36px/42px var(--font-body);
  --heading-2: normal 700 26px/31px var(--font-body);
  --heading-3: normal 700 18px/21px var(--font-body);
  --body-1: normal 400 16px/19px var(--font-body);
  --body-2: normal 400 14px/16px var(--font-body);

  --primary: #004dbc;
  --accent: #0078ff;
  --text-primary: #000337;
  --text-secondary: #35485b;
  --text-tertiary: #919aa4;
  --background: #ffffff;
  --background-2: #f7f7f7;
  --background-3: #ededed;
}

.items {
  justify-content: space-around;
}

.w-16 {
  width: 4rem;
}
</style>

<style src="@/assets/css/sb-admin-2.css" scoped></style>
<style src="@/assets/css/bootstrap-custom.css" scoped></style>
<style src="@/assets/css/styles.css" scoped></style>
<style src="@/assets/css/home.css" scoped></style>
